import { injectIntl, useIntl } from 'react-intl'
import { Elements } from '@tfo/common'
import React from 'react'
import './CookieInformation.scss'
import CookieConsent from "react-cookie-consent";

const cookieConsentStyles: React.CSSProperties = {
    backgroundColor: 'white',
    fontSize: '1rem',
    alignItems: 'center',
    borderTop: '1px solid rgba(0, 0, 0, 0.1)',
    padding: '2rem 3.5rem',
}

const cookieConsentButtonStyles: React.CSSProperties = {
    backgroundColor: 'white',
    color: '#009B48',
    padding: '1rem 2.5rem',
    border: '2px solid #009B48',
    fontSize: '1.5rem',
    fontFamily: 'Arial',


}
const { Paragraph } = Elements
const CookieInfo: React.FunctionComponent = () => {
    const intl = useIntl()


    return (
        <>
            <CookieConsent
                style={cookieConsentStyles}
                buttonStyle={cookieConsentButtonStyles}
                buttonText={intl.formatMessage({ id: 'cookies.confirm' })}
                expires={90}
                cookieName='CookieConsentCup'>
                <Paragraph className="styledParagraph">{intl.formatMessage({ id: 'cookies.info' })}</Paragraph>
            </CookieConsent>
        </>
    )
}
export default injectIntl(CookieInfo)